import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "lodash";

import { queryClient } from "App";
import { RECIPIENTS_TABLE_CONSTANTS } from "routes/recipients/recipients_table/RecipientsTableV3";
import RecipientService from "services/Recipient";
import UserService from "services/User";
import { addResizedColumns } from "./useTableConfig";
import {
  getRecipientsTableColumns,
  getRecipientsTableFilters,
} from "routes/recipients/recipients_table/RecipientsTableColumnsAndFilters";

export const invalidateRecipientsQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [RECIPIENTS_TABLE_CONSTANTS.queryKey],
  });
};

export const deleteRecipient = async id => {
  await RecipientService.delete(id);
  await invalidateRecipientsQuery();
};

export const useRecipientsTable = () => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getRecipientsTableColumns();
    const recipientsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${RECIPIENTS_TABLE_CONSTANTS.tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: recipientsTableSettings?.resized_columns || {},
    });
    return withResizedColumns;
  }, [tableSettings, isTableSettingsFetched]);

  const filters = useMemo(() => getRecipientsTableFilters(), []);

  return { columns, filters };
};
